import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'

import Axios from 'axios'

import Box from 'components_new/atoms/Box'
import Icon from 'components_new/atoms/Icon'
import Text from 'components_new/atoms/Text'

import LoadingSection from 'components_new/molecules/LoadingSection'

import Logotype from 'assets/logotypes/Logotype'

enum State {
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED'
}

const DYNAMICS_ICON = '/assets/media/dynamics365.svg'

const URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990'
    : 'https://api.homepal.se'

const DynamicsLogo = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    <img src={DYNAMICS_ICON} height={50} />
    <Text variant="h3" sx={{ ml: 2 }}>
      Dynamics 365
    </Text>
  </Box>
)

const getContent = (state: State) => {
  switch (state) {
  case State.LOADING:
    return <LoadingSection description={['Aktiverar']} />
  case State.SUCCESS:
    return (
      <>
        <Box>
          <h1>Dynamics har aktiverats</h1>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 4
          }}
        >
          <Box>
            <Logotype />
          </Box>
          <Icon name="SyncAlt" fontSize="large" />
          <DynamicsLogo />
        </Box>
      </>
    )
  case State.FAILED:
    return (
      <>
        <Box>
          <h1>Aktivering misslyckad</h1>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 4
          }}
        >
          <Box>
            <Logotype />
          </Box>
          <Icon name="CancelTwoTone" fontSize="large" />
          <DynamicsLogo />
        </Box>
      </>
    )
  }
}

const DynamicsActivation = (props: any) => {
  const [state, setState] = useState<State>(State.LOADING)

  useEffect(() => {
    const params = new URLSearchParams(props.location.search)

    const error = params.get('error')

    if (!error) {
      const tenant = params.get('tenant')
      const activeSourceId = params.get('state')

      Axios.post(`${URL}/v1/public/dynamics/activate/${activeSourceId}`, {
        data: { tenant }
      })
        .then(() => {
          setState(State.SUCCESS)
        })
        .catch(() => {
          setState(State.FAILED)
        })
    } else {
      setState(State.FAILED)
    }
  }, [])

  return (
    <Box
      sx={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
      }}
    >
      {getContent(state)}
    </Box>
  )
}

export default withRouter(DynamicsActivation)
